import './WriteList.scss'

import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { medalsGroups } from '../../../utilities/constants'
import { useCharacters } from '../../../contexts/Characters'
import { DateTime } from 'luxon'
import Checkbox from '../../forms/Checkbox/Checkbox'
import DateTimePicker from '../../forms/DateTimePicker/DateTimePicker'
import FixedMgeList from '../../domain/FixedMgeList/FixedMgeList'
import Validators from '../../../forms/Validators'
import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import ReasonIcon from '../../domain/ReasonIcon/ReasonIcon'

const WriteList = () => {
    const modal = useModal()
    const characters = useCharacters()
    const { applicants, list } = modal.$state.data
    const [participants, setParticipants] = useState(list?.participants || [])
    const [targets, setTargets] = useState({
        5: { from: 12, to: 13 },
        10: { from: 13, to: 14 },
        12: { from: 14, to: 15 },
        15: { from: 15, to: 16 },
        20: { from: 16, to: 17 },
        30: { from: 17, to: 18 },
        40: { from: 18, to: 19 },
        60: { from: 19, to: 20 },
        80: { from: 20, to: 21 },
        100: { from: 21, to: 22 },
    })

    const toggleFromList = (character, status) => {
        if (status) {
            const alreadyPresent = participants.some((participant) => participant._id === character._id)
            if (!alreadyPresent) setParticipants([ ...participants, character ])
        } else {
            setParticipants(participants.filter((participant) => participant._id !== character._id))
        }
    }

    const saveListRef = useRef()
    saveListRef.current = () => {
        const participantsIds = participants.map((participant) => participant._id)
        const targets = targetsForm.$state.value
        const server = characters.$state.current.server._id
        const options = optionsForm.$state.value
        const listData = { participants: participantsIds, targets, server, ...options }
        if (list?._id) {
            koalition.put(`/lists/${list._id}`, listData).then((response) => {
                modal.close()
                toaster.success('List updated successfully')
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
            })
        } else {
            koalition.post('/lists', listData).then((response) => {
                modal.close()
                toaster.success('List created successfully')
            }).catch((error) => {
                toaster.error(error)
                console.error(error)
            })
        }
    }

    const onFirstRoundSelectionClick = () => {
        Object.values(selectionForm.$state.controls).forEach((control, index) => control.setValue(index < 25 || index >= 50 && index < 75))
        setParticipants([ ...applicants.slice(0, 25), ...applicants.slice(50, 75) ])
    }

    const onSecondRoundSelectionClick = () => {
        Object.values(selectionForm.$state.controls).forEach((control, index) => control.setValue(index < 50))
        setParticipants(applicants.slice(0, 50))
    }

    const optionsForm = useFormBuilder({ controls: {
        week: { value: list?.week || DateTime.utc().startOf('week').ts }
    } })
    const selectionForm = useFormBuilder({ controls: Object.fromEntries(applicants.map((applicant) => [applicant._id, { value: list?.participants?.some((participant) => participant._id === applicant._id) }])) })
    const targetsForm = useFormBuilder({ controls: Object.fromEntries(medalsGroups.map((group) => [
        group.medals,
        { type: 'group', controls: {
            from: { validators: [Validators.required], value: list ? list.targets[group.medals].from : group.targets.from },
            to: { validators: [Validators.required], value: list ? list.targets[group.medals].to : group.targets.to }
        } }
    ])) })

    useEffect(() => {
        modal.configure({ actions: [{ label: 'Save', onClick: () => saveListRef.current() }] })
    }, [])

    return (
        <div className="h-100">
            <main className="row write-list h-100">
                <div className="col-md-auto applicants h-100 mb-4">
                    <div className="card h-100">
                        <div className="row h-100 flex-column">
                            <main className="col px-0">
                                <ul className="applicants-list px-4">
                                    {applicants.map((applicant, index) => (
                                        <li className={`row applicant align-items-center ${participants.some((character) => character._id === applicant._id) ? 'selected' : 'available'}`} key={applicant._id}>
                                            <div className="col-auto pr-0"><Checkbox control={selectionForm.$state.controls[applicant._id]} onChange={(status) => toggleFromList(applicant, status)} /></div>
                                            <div className="col-auto rank pl-0">{index + 1}</div>
                                            <div className="col-auto reason pl-0">
                                                <ReasonIcon reason={applicant.reason} partialReceived={applicant.partialReceived} />
                                            </div>
                                            <div className="col-auto name pl-0">{applicant.name}</div>
                                        </li>
                                    ))}
                                </ul>
                            </main>

                            <footer className="col-auto mt-4">
                                <div className="mb-3">
                                    <DateTimePicker control={optionsForm.$state.controls.week} label="Week" />
                                </div>
                                <button className="primary small mr-3" onClick={onFirstRoundSelectionClick}>First Round</button>
                                <button className="primary small" onClick={onSecondRoundSelectionClick}>Second Round</button>
                            </footer>
                        </div>
                    </div>
                </div>

                <div className="col-md list mb-4 h-100">
                    <FixedMgeList editable={true} targetsForm={targetsForm} participants={participants} setParticipants={setParticipants} targets={targets} setTargets={setTargets} />
                </div>
            </main>
        </div>
    )
}

export default WriteList